module.exports = __webpack_public_path__ + "media/images/white_h_herospark-ff3c549d4d8de7f39669f41bb07577a9.png";